
import { SET_CURRENT_TAB, SET_VEHICLE_ID, SET_TOPIC_ID, SET_SSTORE_ID, SET_SMS_ID } from '../mutationTypes'

const state = {
    currentTab: 0,
    vehicle_id: '',
    topic_id: '',
    sstore_id: '',
    sms_id: ''
}

const mutations = {
    [SET_CURRENT_TAB] (state, res) {
        state.currentTab = res
    },
    [SET_VEHICLE_ID] (state, res) {
        state.vehicle_id = res
    },
    [SET_TOPIC_ID] (state, res) {
        state.topic_id = res
    },
    [SET_SSTORE_ID] (state, res) {
        state.sstore_id = res
    },
    [SET_SMS_ID] (state, res) {
        state.sms_id = res
    }
}

export const actions = {

}

export const getters = {

}

export default {
    state,
    mutations
}
